<template>
  <div class="containerBlock">
    <h3 class="titleBorder">基础信息</h3>
    <a-row class="rowBox">
      <a-col :span="8" class="itemStyle">
        动物类型：{{details.animalTypeName}}
      </a-col>
      <a-col :span="8" class="itemStyle">
        配方模型：{{details.formulaModelName}}
        <a-checkbox default-checked disabled >
          {{details.isFilledModel == 1 ? '填充配方' : '不填充配方'}}
        </a-checkbox>
      </a-col>
      <a-col :span="8" class="itemStyle">
        养分选择表：{{details.animalNutritionName}}
      </a-col>
      <a-col :span="8" class="itemStyle">
        价格来源：{{details.priceSourceName}}
      </a-col>
      <a-col :span="8" class="itemStyle">
        盘重：{{details.totalWeight}}{{details.totalWeightUnit || 'kg'}}
      </a-col>
      <a-col :span="8" class="itemStyle">
        水分挥发：<span v-if="details.moistureVolatilizeStart">{{details.moistureVolatilizeStart}}%</span>
      </a-col>
      <a-col :span="8" class="itemStyle">
        分析基础：{{details.analysisBase}} {{details.analysisBaseUnit}}
      </a-col>
      <a-col :span="16">
        备注：{{details.remark}}
      </a-col>
    </a-row>
  </div>
</template>


<script>
export default {
  props: ['details'],
  data(){
    return{

    }
  }
}
</script>
